import { render, staticRenderFns } from "./mobileNet.vue?vue&type=template&id=928addb0"
import script from "./mobileNet.vue?vue&type=script&lang=js"
export * from "./mobileNet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports